import * as React from 'react'
import { bind } from 'classnames/bind'
import cxRaw from 'classnames'
import * as styles from '@procore/core-css/src/components/_icon.scss'

import { Props, SizeNS, SpanAttributes } from '../utils/types'

export type IconSize =
  | typeof SizeNS.inherit
  | typeof SizeNS.sm
  | typeof SizeNS.md
  | typeof SizeNS.lg

export namespace IconVariantNS {
  export const none = ''
  export const hoverCircle = 'hover-circle'
  export const hoverFill = 'hover-fill'
}

type IconVariant =
  | typeof IconVariantNS.none
  | typeof IconVariantNS.hoverCircle
  | typeof IconVariantNS.hoverFill

export interface IconProps extends Props {
  clickable?: boolean
  icon: string
  size?: IconSize
  variant?: IconVariant
}

const cx = bind(styles)

const Icon = React.forwardRef<HTMLSpanElement, SpanAttributes & IconProps>(
  (
    {
      className,
      clickable = false,
      icon,
      size = SizeNS.inherit,
      variant = IconVariantNS.none,
      ...props
    },
    ref
  ) => (
    <span
      ref={ref}
      className={cxRaw(
        'ci',
        `ci-${icon}`,
        cx('core-icon', {
          'core-icon--clickable': clickable,
          [`core-icon--${size}`]: size,
          [`core-icon--${variant}`]: variant,
        }),
        className
      )}
      {...props}
    />
  )
)

Icon.displayName = 'Icon'

export default Icon
